import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

export type RepeatableRowActionsLayout = 'desktop' | 'mobile';

@Component({
    selector: 'app-repeatable-row-actions',
    standalone: false,
    templateUrl: './repeatable-row-actions.component.html',
    styleUrls: ['./repeatable-row-actions.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RepeatableRowActionsComponent {
    @Input() public layout: RepeatableRowActionsLayout = 'desktop';
    @Input() public isEditable = true;
    @Input() public canDeleteRow = false;
    @Input() public showProductInfo = false;
    @Input() public disabledDelete = false;

    @Output() public productInfoRequested = new EventEmitter<void>();
    @Output() public deleteRequested = new EventEmitter<void>();

    public get containerClass(): Record<string, boolean> {
        return {
            'repeatable-actions': this.layout === 'desktop',
            'repeatable-actions-desktop': this.layout === 'desktop',
            'repeatable-actions-mobile': this.layout === 'mobile',
        };
    }
}
